import { InterviewResult } from '../types/InterviewResult';
import { PutInterviewResultsAnswers } from '../types/interviewResultsAnswersApiTypes';

export const toPutInterviewResultsAnswers = (
  interviewResult: InterviewResult,
  version: number,
): PutInterviewResultsAnswers => {
  return {
    answers: interviewResult.answers.map((answer) => ({
      id: answer.answerId,
      question_id: answer.questionId,
      answer_items: answer.answerItems.map((item) => ({
        id: item.answerItemId,
        question_item_id: item.questionItemId,
        description: item.description,
        checked: item.checked,
        choice_notes: item.choiceNotes,
      })),
    })),
    version,
  };
};
